import { render, staticRenderFns } from "./Manage-Payment-Terms.vue?vue&type=template&id=f14b4f14"
import script from "./Manage-Payment-Terms.vue?vue&type=script&lang=js"
export * from "./Manage-Payment-Terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports